





















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicView from "@/components/pic-preview.vue";
import { SaveShixinQuestionResult$ } from "@/request/shezhenjiaoxue";
@Component({
  components: {
    PicView,
  },
})
export default class SzsxDanxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private len;
  private selectedValue: any = "";
  private ifShowPic: boolean = false;
  private ifShowAnswer: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  @Watch("index", { immediate: true })
  private indexChange() {
    this.ifShowAnswer = false;
    this.selectedValue = "";
  }

  /**
   * @description 记录学习结果
   */
  private saveQuestionStudy() {
    const index = this.question["选项"].indexOf(this.selectedValue);
    const params: any = {
      question_id: this.question["question_id"],
      reply: [index],
    };
    SaveShixinQuestionResult$(this, params).then((data: any) => {
      console.log(data);
    });
  }
  /**
   * @description 上一题
   */
  private prev() {
    if (this.selectedValue === 0 || this.selectedValue) {
      this.saveQuestionStudy();
    }

    this.$emit("prev");
  }
  /**
   * @description 下一题
   */
  private next() {
    if (this.selectedValue === 0 || this.selectedValue) {
      this.saveQuestionStudy();
    }
    this.$emit("next");
  }
  /**
   * @description 选择某个
   */
  private selectThis(o) {
    this.selectedValue = o;
  }
  /**
   * @description 展示答案
   */
  private showAnswer() {
    this.ifShowAnswer = true;
  }
  /**
   * @description 判断是否答对
   */
  private ifCorrect(oi) {
    if (oi === this.question["正确答案"][0]) {
      return true;
    } else {
      return false;
    }
  }
}
